<mat-form-field class="field">
    <input matInput
           [type]="passwordControlType"
           [placeholder]="placeholder"
           [formControl]="formControl"
           [id]="formName"
           [name]="formName"
           [autocomplete]="autocomplete">

    <mat-icon matSuffix
              color="accent"
              class="password-icon"
              (click)="onTogglePasswordField()">
        {{passwordIcon}}
    </mat-icon>
    <mat-hint *ngIf="shouldDisplayRequirements">
        Must have at least 12 characters and 1 each of: uppercase, lowercase, special characters, digits
    </mat-hint>

    <mat-error *ngIf="formControl.hasError('required')">
        Field is required.
    </mat-error>

    <mat-error *ngIf="formControl.hasError('minlength')">
        Password must have 12 or more characters:
        {{formControl.getError('minlength').actualLength}}
        /{{formControl.getError('minlength').requiredLength}} characters.
    </mat-error>

    <mat-error *ngIf="formControl.hasError('pattern')">
        Must have at least 1 each of: uppercase, lowercase, special characters, digits
    </mat-error>

    <mat-error *ngIf="formControl.hasError('requiredSibling')">
        You must enter both a value for password and confirm password
    </mat-error>

    <mat-error *ngIf="formControl.hasError('mismatch')">
        Confirm Password must match the Password field.
    </mat-error>
</mat-form-field>
